/* Device preferences: theme, text size, units, map style. Light is the default everywhere. */
import { create } from 'zustand'
import { load, save } from './storage'

export type Units = 'km' | 'mi'
export interface Prefs {
  theme: 'light' | 'dark'
  size: '0' | '1' | '2'
  units: Units
  mapStyle: 'map' | 'sat'
}

const defaultUnits = (): Units => {
  try {
    const l = (navigator.languages && navigator.languages[0]) || navigator.language || ''
    return /^en-(US|LR|MM)\b/i.test(l) || l === 'en' ? 'mi' : 'km'
  } catch {
    return 'km'
  }
}

const initial: Prefs = { theme: 'light', size: '0', units: defaultUnits(), mapStyle: 'map', ...load<Partial<Prefs>>('prefs', {}) }

export const usePrefs = create<Prefs & { set: (p: Partial<Prefs>) => void }>((set, get) => ({
  ...initial,
  set: (p) => {
    set(p)
    const { theme, size, units, mapStyle } = get()
    save('prefs', { theme, size, units, mapStyle })
    applyPrefs()
  },
}))

export function applyPrefs() {
  const p = usePrefs.getState()
  const root = document.documentElement
  root.dataset.theme = p.theme === 'dark' ? 'dark' : 'light'
  root.dataset.size = p.size
  const meta = document.querySelector('meta[name="theme-color"]')
  if (meta) meta.setAttribute('content', p.theme === 'dark' ? '#0e1913' : '#e7f2eb')
}
